import { Link } from 'react-router-dom';

export default function PulseList({ posts }) {
  return (
    <div className="pulse-list">
      {posts.map((p) => (
        <Link to={`/market-pulse/${p.slug}`} className="pulse-row" key={p.slug}>
          <div>
            <h3 className="pulse-row__title">{p.title}</h3>
            <p className="muted" style={{ fontSize: '0.95rem' }}>{p.summary}</p>
            <div className="pulse-card__meta" style={{ marginTop: '0.6rem' }}>
              {(p.tags || []).slice(0, 3).map((tag) => (
                <span className="tag" key={tag}>{tag}</span>
              ))}
            </div>
          </div>
          <span className="pulse-row__date">
            {new Date(p.date).toLocaleDateString(undefined, { day: 'numeric', month: 'short' })}
          </span>
        </Link>
      ))}
    </div>
  );
}
